// DeskCrumbs — the focus view's breadcrumb (#161): Project › Course ›
// Module › Document. Every level above the one shown is a step back to it;
// the project ends focus. Quiet: dim text, no borders; the level shown is
// in the ink colour. Pure.

export type { DeskCrumb };
export { DeskCrumbs };

import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";

type DeskCrumb = { readonly id: string; readonly title: string };

const DeskCrumbs = ({
    project,
    crumbs,
    current,
    onCrumb,
}: {
    // The project's name: the first step, back to the desk.
    readonly project: string;
    // The levels above the one shown, from the outermost down.
    readonly crumbs: readonly DeskCrumb[];
    // The level shown ("1.3", or its title).
    readonly current: string;
    // Back to the level `id` (null: the desk, ending focus).
    readonly onCrumb: (id: string | null) => void;
}): ReactNode => {
    const { t } = useLingui();
    return (
        <nav className="bilda-desk__crumbs" aria-label={t`Breadcrumb`}>
            <button type="button" title={project} onClick={() => onCrumb(null)}>
                {project}
            </button>
            {crumbs.map((c) => (
                <span key={c.id} className="bilda-desk__crumb">
                    <span aria-hidden="true">›</span>
                    <button
                        type="button"
                        title={c.title}
                        onClick={() => onCrumb(c.id)}
                    >
                        {c.title}
                    </button>
                </span>
            ))}
            <span className="bilda-desk__crumb" aria-current="page">
                <span aria-hidden="true">›</span>
                <span className="bilda-desk__crumb-here" title={current}>
                    {current}
                </span>
            </span>
        </nav>
    );
};
